import { render, staticRenderFns } from "./RequestVam.vue?vue&type=template&id=6ee4ddb2&scoped=true&"
import script from "./RequestVam.vue?vue&type=script&lang=js&"
export * from "./RequestVam.vue?vue&type=script&lang=js&"
import style0 from "./RequestVam.vue?vue&type=style&index=0&id=6ee4ddb2&scoped=true&lang=css&"
import style1 from "./RequestVam.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee4ddb2",
  null
  
)

export default component.exports